import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/reportTemplateCategory'
import { EditReportTemplateCategoryDialog } from './dialog'

class EditReportTemplateCategoryDialogShell extends React.Component {
  componentDidMount () {
    this.props.get(this.props.id)
  }
  render () {
    const { dialogKey, reportTemplateCategory, closeDialog, fetching, updating } = this.props
    return (
      <EditReportTemplateCategoryDialog
        key={dialogKey}
        title='Reporting.Category'
        reportTemplateCategory={reportTemplateCategory}
        loading={fetching}
        updating={updating}
        closeDialog={closeDialog}
        onAction={dto => {
          this.props.save(dto, () => this.props.closeDialog())
        }}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    ...state.reportTemplateCategory
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  save: actionCreators.save
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(EditReportTemplateCategoryDialogShell)
}



// WEBPACK FOOTER //
// ./src/dialogs/editReportTemplateCategory/index.js